"use client";

import { usePathname } from "next/navigation";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

import { useAppDispatch, useAppSelector } from "@/redux/store";
import { sendSexyAdClick } from "@/redux/actions";
import DesktopBanner from "@/assets/adverts/sexy_ad_banner.webp";
import MobileBanner from "@/assets/adverts/sexy_ad_banner_mobile.webp";
import SquareAd from "@/assets/adverts/sexy_ad2_square.webp";

interface SexyAdProps {
  variant: "banner" | "square";
  className?: string;
}

const SexyAd: React.FC<SexyAdProps> = ({ variant, className }) => {
  const dispatch = useAppDispatch();
  const pathname = usePathname();
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user?.subscriptionType !== "free");
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  const handleAdClick = () => {
    dispatch(
      sendSexyAdClick({
        pageUrl: `${process.env.NEXT_PUBLIC_BASE_URL}${pathname}`,
      })
    );
  };

  if (isSubscribed) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "1rem auto",
        maxWidth: "100%",
        width: variant === "banner" ? "100%" : "300px",
      }}
      className={className}
    >
      <a
        href="https://nomi.ai/?via=idyllic"
        target="_blank"
        onClick={handleAdClick}
        style={{ textDecoration: "none", width: "100%" }}
      >
        <img
          src={
            variant === "banner"
              ? isMobile
                ? MobileBanner.src
                : DesktopBanner.src
              : SquareAd.src
          }
          alt="Idyllic Ad"
          style={{
            width: "100%",
            maxWidth: variant === "banner" ? "100%" : "300px",
            height: "auto",
            display: "block",
          }}
        />
      </a>
    </div>
  );
};

export default SexyAd;
